import React from "react";
import { User } from "lucide-react";
import OtpLogin from "../../components/OtpLogin";
import { HERO_IMAGES } from "../../lib/mockData";

export default function CustomerLogin() {
  return (
    <OtpLogin
      role="Customer"
      roleKey="customer"
      subtitle="Log in to submit your innovation, compare quotes, and track your patents."
      redirectTo="/portal"
      accentIcon={User}
      sideImage={HERO_IMAGES.innovators}
      sidePoints={[
        "Submit innovations & get matched with attorneys",
        "Compare tentative quotes side-by-side",
        "Track every patent from filing to grant",
      ]}
    />
  );
}
